<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue'
import { useConfigStore, useLoadingStore, useToastStore } from '@/stores'
import { KS } from '@/kuaishou'
import { api } from '@/api'
import { $log } from '@/helpers'
import { track } from '@/track'

defineProps<{
  value: boolean
}>()
const emit = defineEmits<{
  (event: 'input', value: boolean): void
}>()

const { $showLoading, $hideLoading } = useLoadingStore()
const { $toast } = useToastStore()
const configStore = useConfigStore()

const modal = ref(true)
const adVideoPlayer = ref(false)
const adVideoData = ref<{ sessionId: string; src: string; poster: string; isDownload: boolean; [key: string]: any }>({ sessionId: '', src: '', poster: '', isDownload: false })

const coin = ref(0)
onMounted(async () => {
  try {
    const { data } = await api.post('/kuaishou/ad/inspireNovelAbTest', ['col_daily_login_reward'])
    const [_key, value] = data.abResult.col_daily_login_reward.split('=')
    coin.value = Number(value)
  }
  catch (error) {
    coin.value = configStore.$state.indexDailyPopupCoin
  }
})

async function onReceive() {
  $log('Component: BizModalDailyRedPack', '#onReceive')
  $showLoading()
  try {
    track('inspireVideo', { name: 'skyRedPack', type: 'start' })
    await KS.playAdVideo({
      type: 3,
      extParams: {
        scene: 'colEnableFirstAdVideoPop',
      },
      success(data: any) {
        track('inspireVideo', { name: 'skyRedPack', type: 'end' })
        $log('Component: BizModalDailyRedPack', '#onReceive ~> success', { data })
        $toast('看完广告视频, 金币领取成功')
        emit('input', false)
      },
      fail(error: any) {
        track('inspireVideo', { name: 'skyRedPack', type: 'cancel' })
        $log('Component: BizModalDailyRedPack', '#onReceive ~> fail', { error })
        $toast('未看完视频，红包飞走了')
        emit('input', false)
      },
    })
    // modal.value = false
  }
  catch {}
  finally {
    $hideLoading()
  }
}

const countdowning = ref(true)
function onEndCountdown() {
  countdowning.value = false
}
function onContinue() {
  emit('input', false)
}

watch(() => [modal.value, adVideoPlayer.value], () => {
  if (!modal.value && !adVideoPlayer.value)
    emit('input', false)
})

function onCancelAdVideo() {
  $toast('未看完视频，红包飞走了')
}
function onEndAdVideo() {
  $toast('看完广告视频, 金币领取成功')
  emit('input', false)
}

function trackElementClickClose() {
  track('elementClick', {
    name: 'skyRedPackClose',
    coin: coin.value,
  })
}
</script>

<template>
  <portal to="root" :order="50">
    <BizTrackShow
      v-if="modal"
      name="skyRedPack" type="modal" :extra="{ coin }" :delay="1.5"
      class="modalDailyRedPack px-10 flex flex-col justify-center fixed inset-0 z-100"
    >
      <div
        class="fixed inset-0 bg-black opacity-60"
        @click="() => {
          $emit('input', false)
          trackElementClickClose()
        }"
      />
      <div class="mt-12 w-full relative">
        <img class="w-full" src="@/assets/modal-daily-red-pack-background.png" @click="onReceive">
        <p class="text-13px text--colorful font-bold absolute left-1/2 -translate-x-1/2 top-6.5">
          恭喜获得
        </p>
        <p class="flex items-baseline whitespace-nowrap absolute top-1/3 left-1/2 -translate-1/2">
          <span class="text--colorful mx-2 text-75px lh-1em font-bold">{{ coin === 0 ? '...' : coin }}</span>
          <span class="text--colorful text-xl font-bold relative -top-2">金币</span>
        </p>
      </div>
    </BizTrackShow>

    <!-- <BizAdVideoPlayer
      v-if="adVideoPlayer"
      v-model="adVideoPlayer" :session-id="adVideoData.sessionId"
      :src="adVideoData.src" :poster="adVideoData.poster" :caption="adVideoData.caption"
      :is-download="adVideoData.isDownload" :action-bar="adVideoData.actionBar" :action-bar-color="adVideoData.actionBarColor"
      @end="onEndAdVideo" @cancel="onCancelAdVideo"
    /> -->
  </portal>
</template>

<style>
.modalDailyRedPack .text--colorful {
  @apply bg-gradient-to-b from-#FFF8BB to-#FFB803 text-transparent bg-clip-text
}
</style>
